import React, { useContext, useState, useEffect } from "react";
import ControlContext from "../../contexts/control-context";
import Line from "../Workspace/SVGLayer/shapes/Line";
import Rect from "../Workspace/SVGLayer/shapes/Rect";
import Ellipse from "../Workspace/SVGLayer/shapes/Ellipse";
import Text from "../Workspace/SVGLayer/shapes/Text";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import "./Presentation.css"; 

const Presentation = () => {

    const {
        shapes,
        shapesMap,
        frames,
        framesMap,
        selectedFrameId,
    } = useContext(ControlContext)

    var [currFrame, changeFrame] = useState(0);
    const handle = useFullScreenHandle();

    const genShape = (shapeData, key = undefined) => {
        const {
            initCoords,
            finalCoords,
            borderColor,
            borderWidth,
            fillColor,
            fontSize,
            fontfamily,
            oldText,
            newText,
            id,
        } = shapeData;
        switch (shapeData.type) {
          case "line": {
            return React.createElement(Line, {
              x1: initCoords.x,
              y1: initCoords.y,
              x2: finalCoords.x,
              y2: finalCoords.y,
              borderColor,
              borderWidth,
              id,
              key,
            });
          }
          case "rect": {
            return React.createElement(Rect, {
              x: Math.min(initCoords.x, finalCoords.x),
              y: Math.min(initCoords.y, finalCoords.y),
              width: Math.abs(finalCoords.x - initCoords.x),
              height: Math.abs(finalCoords.y - initCoords.y),
              fillColor,
              borderColor,
              borderWidth,
              id,
              key,
            });
          }
          case "ellipse": {
            let x = Math.min(finalCoords.x, initCoords.x);
            let y = Math.min(finalCoords.y, initCoords.y);
            let w = Math.abs(finalCoords.x - initCoords.x);
            let h = Math.abs(finalCoords.y - initCoords.y);
    
            return React.createElement(Ellipse, {
              cx: x + w / 2,
              cy: y + h / 2,
              rx: w / 2,
              ry: h / 2,
              fillColor,
              borderColor,
              borderWidth,
              id,
              key,
            });
          }
          case "text": {
            return React.createElement(Text, {
              x: initCoords.x,
              y: initCoords.y,
              oldText,
              newText,
              fillColor,
              fontsize: fontSize,
              fontfamily: fontfamily,
              id,
              key,
            });
          }
          default: {
            return null;
          }
        }
      };
    
    const renderShape = (shapeData, key) => {
        if (shapeData.visible && shapeData.frame === frames[currFrame]) {
          return genShape(shapeData, key);
        } else {
          return null;
        }
    };

    const fullScreenHandler = (e) => {
      if (e.key === "f") {
        handle.enter();
      }
    }

    const arrowKeyHandler = (e) => {
        if (e.key === "ArrowRight" && currFrame < frames.length - 1) {
            changeFrame(currFrame + 1);
        } else if (e.key === "ArrowLeft" && currFrame > 0) {
            changeFrame(currFrame - 1);
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", arrowKeyHandler, true);
        window.addEventListener("keydown", fullScreenHandler, true);
        return () => {
          window.removeEventListener("keydown", arrowKeyHandler, true);
          window.removeEventListener("keydown", fullScreenHandler, true);
        }
      }, [arrowKeyHandler]);

    return (
      <FullScreen handle={handle}>
        <div className="presentation" style={{background: "white"}}>
            {console.log(shapes, frames, selectedFrameId)}
            <svg viewBox="0 0 800 600" onClick={(e) => {
                // if the svg clicked on has a frame interaction, execute it
                console.log(e.target.tagName)
                if (e.target.tagName !== "svg" && shapesMap[e.target.id].frameInteraction != null){
                    changeFrame(frames.indexOf(shapesMap[e.target.id].frameInteraction))
                }
            }}>
                {shapes.map((shapeId, idx) => {
                    console.log(shapesMap[shapeId], idx);
                    var shape = renderShape(shapesMap[shapeId], idx)
                    console.log(shape)
                    return shape;
                })}
            </svg>
        </div>
      </FullScreen>
    )
};

export default Presentation;